import BaseTiles from './BaseTiles';

export { type BaseTilesProps } from './BaseTiles';
export default BaseTiles;
